<div class="card-header position-relative">

    <div class="back-btn-wrapper">
        <app-back-button></app-back-button>
    </div>

    <h2 class="m-0">
        {{ titulo }}
    </h2>

    <div class="paciente-header">
        <span class="paciente-chip">
            <i class="fas fa-user-circle"></i>
            Monitorando:
            <strong>{{ pacienteNome }}</strong>
        </span>
    </div>

    <span class="icon-container" *ngIf="showHelp" (click)="help.emit()">
        <i class="fas fa-info-circle icon"></i>
    </span>

</div>
